import { PageTitle } from "@/components/Common";
import { PanelRegistroQR } from "@/components/PanelRegistroQR";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function AdminRegistro() {
  return (
    <div data-testid="admin-registro">
      <PageTitle title="Registro por código QR"
                 subtitle="Comparta o imprima el QR de padres y el de docentes. Cada solicitud queda pendiente de su aprobación." />

      <Tabs defaultValue="tutor" className="mt-2">
        <TabsList data-testid="tabs-registro">
          <TabsTrigger value="tutor" data-testid="tab-registro-padres">Padres y tutores</TabsTrigger>
          <TabsTrigger value="docente" data-testid="tab-registro-docentes">Docentes</TabsTrigger>
        </TabsList>
        <TabsContent value="tutor" className="mt-6">
          <PanelRegistroQR rol="tutor" />
        </TabsContent>
        <TabsContent value="docente" className="mt-6">
          <PanelRegistroQR rol="docente" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
